import { render, staticRenderFns } from "./RouterCom.vue?vue&type=template&id=4a881205&"
import script from "./RouterCom.vue?vue&type=script&lang=ts&"
export * from "./RouterCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports